"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.DocumentListWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var plugin_journey_1 = require("@athena-portal/plugin-journey");
var DocumentListModal_1 = require("./DocumentListModal");
var DocumentListWidget = /** @class */ (function (_super) {
    __extends(DocumentListWidget, _super);
    function DocumentListWidget(props) {
        return _super.call(this, props) || this;
    }
    DocumentListWidget.prototype.render = function () {
        return ((0, jsx_runtime_1.jsxs)("div", { id: this.props.question.name, className: "documents-widget documents-output-widget ".concat(this.getSetting("cssClass", "")), children: [this.props.question.label ? ((0, jsx_runtime_1.jsx)("h2", { className: "font-family-base font-weight-semi-bold text-blue-2 fs-18", children: this.props.question.label })) : "", this.getSetting("helpText", undefined) ? ((0, jsx_runtime_1.jsx)("p", { children: this.getSetting("helpText", "") })) : "", (0, jsx_runtime_1.jsx)(DocumentListModal_1.DocumentListModal, { productName: this.props.interaction.product, policyDate: new Date(this.props.interaction.factors.originalQuoteDate), isMLEVisible: this.props.interaction.optionalExtras.motorLegalExpenses, isAccordion: false, coverTier: this.props.interaction.coverTier, brand: this.props.interaction.brandName })] }));
    };
    return DocumentListWidget;
}(plugin_journey_1.WidgetBase));
exports.DocumentListWidget = DocumentListWidget;
//# sourceMappingURL=DocumentListWidget.js.map